/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const getStoreLocations = gql`
    query storeLocation{
        storeLocation{
            items {
                address
                baseimage
                city
                country_id
                email
                engraving
                latitude
                link
                longitude
                phone
                state
                store_name
                storepickup_id
                zipcode
                rewrite_request_path
                meta_description
                meta_keywords
                meta_title
            }
        }
    }
`;
